<template>
  <el-container class="app-layout">
    <el-header style="padding: 0">
      <app-header></app-header>
    </el-header>

    <el-container
      class="app-content"
      v-loading="load"
      element-loading-text="加载中..."
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
      <el-aside width="200px">
        <transition name="el-zoom-in-top">
          <app-slide></app-slide>
        </transition>
      </el-aside>

      <el-main class="app-content-right">
        <el-tabs
          v-model="path"
          type="card"
          closable
          @tab-click="changeTab"
          @tab-remove="handleTabsEdit"
        >
          <el-tab-pane
            v-for="(tab, index) in tabs"
            :key="index"
            :label="tab.name"
            :name="tab.path"
          ></el-tab-pane>
        </el-tabs>

        <transition name="fade-transform" mode="out-in">
          <keep-alive v-if="tabs.indexOf($route.path) != -1">
            <router-view
          /></keep-alive>
          <!-- 顶部导航条路由切换不刷新 -->
          <keep-alive v-else>
             <router-view /> 
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import AppHeader from "./header";
import AppSlide from "./slide.vue";
export default {
  name: "Layout",
  components: {
    AppHeader,
    AppSlide,
  },
  computed: {
    load() {
      return this.$store.state.config.loading;
    },
    path() {
      return this.$route.path;
    },
    ...mapState({
      tabs: (state) => state.tabs,
    }),
  },
  methods: {
    changeTab(tab) {
      if (this.$route.path != tab.name) {
        this.$router.push(tab.name).catch(() => {});
      }
    },
    handleTabsEdit(path) {
      if (this.tabs.length == 1) {
        return false;
      }
      this.tabs.forEach((e, index) => {
        if (e.path == path) {
          if (index == 0) {
            this.$router.push(this.tabs[index + 1].path).catch(() => {});
          } else {
            // console.log(e.path,this.$route.path);
            if (this.$route.path == e.path) {
              this.$router.push(this.tabs[index - 1].path).catch(() => {});
            }
            
          }
        }
      });
      this.$store.commit("tabDel", path);
    },
  },
};
</script>

<style lang="less">
.app-layout {
  width: 100%;
  height: 100%;
}
.app-content {
  width: 100%;
  height: calc(100% - 61px);
}
.app-content-right {
  background-color: #f2f2f2;
}
.el-tabs {
  background-color: #fff;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-left: none;
}

/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
